import {
  Box,
  Button,
  Icon,
  List,
  Modal,
  Text,
  Title,
} from '@nimbus-ds/components';
import { ExternalLinkIcon } from '@nimbus-ds/icons';
import { openWindow } from 'commons/utils/window';
import useTranslationPagoNubeOnboarding from 'domains/PagoNubeOnboarding/useTranslationPagoNubeOnboarding';

interface CompanyModalProps {
  stripeFormLink: string;
  showModal: boolean;
  closeModal: () => void;
}

export default function CompanyModal({
  stripeFormLink,
  showModal,
  closeModal,
}: CompanyModalProps) {
  const t = useTranslationPagoNubeOnboarding('companyModal');

  const handleConfirmAction = () => {
    openWindow(stripeFormLink, true);
    closeModal();
  };

  return (
    <Modal open={showModal} onDismiss={closeModal}>
      <Modal.Header>
        <Box
          alignItems="center"
          display="flex"
          gap="4"
          justifyContent="space-between"
        >
          <Title as="h3">{t('title')}</Title>
        </Box>
      </Modal.Header>
      <Modal.Body>
        <Box marginBottom="4">
          <Text>{t('description')}</Text>
        </Box>
        <Box marginLeft="4" marginBottom="4">
          <List as="ul">
            <List.Item>{t('documentationRequirement')}</List.Item>
            <List.Item>{t('verificationProcess')}</List.Item>
            <List.Item>{t('processingTime')}</List.Item>
            <List.Item>{t('additionalInformation')}</List.Item>
          </List>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={closeModal} appearance="neutral">
          {t('cancelButton')}
        </Button>
        <Button onClick={handleConfirmAction} appearance="primary">
          {t('confirmButton')}
          <Icon color="currentColor" source={<ExternalLinkIcon />} />
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
